import axios from 'axios'; //Axios library for making HTTP requests
import { createHeaders } from './headerUtils'; // Creating the headers required for the request

const BASE_URL = process.env.REACT_APP_BASE_URL; // Base url for the API 

// Object that includes functions to get company and create a new company
const apiCreateCompanies = {
  getCompany: async (companyid) => {
    try {
      const apiUrl = `${BASE_URL}/companies/${companyid}`;  // Constructing the API URL for fetching company data
      const headers = createHeaders(); // Calling a function to create headers for the HTTP request
      console.log("apiCreateCompanies (ok): getCompany ", `Querying: ${apiUrl}`); // Logging a message indicating the API URL being queried
      const response = await axios.get(apiUrl, { headers }); // Making a GET request to fetch company data from the API
      return response.data;
    } catch (error) {
      console.log("apiCreateCompanies (ERROR): getCompany ", error.message)
      throw error;
    }
  },
  
  createCompany: async (newCompanyData) => {
    try {
      const apiUrl = `${BASE_URL}/companies/create`; // Constructing the API URL for fetching company data
      const headers = createHeaders(); // Calling a function to create headers for the HTTP request
      const response = await axios.post(apiUrl, newCompanyData, { headers }); // Making a GET request to create company data from the API
      return response.data;
    } catch (error) {
      console.log("apiCreateCompanies (ERROR): createCompany ", error.message)
      throw error;
    }
  },

  getBundle: async () => {
    try {
      const apiUrl = `${BASE_URL}/companies/bundle`; // Constructing the API URL for fetching bundle data
      const headers = createHeaders(); // Calling a function to create headers for the HTTP request
      console.log("Fetching bundle data", apiUrl);
      const response = await axios.get(apiUrl, { headers }); // Making a GET request to fetch bundle data from the API
      return response.data;
    } catch (error) {
      console.log("Error fetching bundle data:", error);
      throw error;
    }
  },

  getEntitlements: async () => {
    try {
      const apiUrl = `${BASE_URL}/companies/entitlements`; // Constructing the API URL for fetching bundle data
      const headers = createHeaders(); // Calling a function to create headers for the HTTP request
      console.log("Fetching entitlements data", apiUrl);
      const response = await axios.get(apiUrl, { headers });  // Making a GET request to fetch bundle data from the API
      return response.data;
    } catch (error) {
      console.log("Error fetching entitlements data:", error);
      throw error;
    }
  }
};

export default apiCreateCompanies;